import { useEffect } from 'react';

export const useStopScroll = (enabled: boolean) => {
  useEffect(() => {
    if (enabled) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [enabled]);
};
